/**
 * Pace used for %CP → sec/km on work segments: faster of training vs ceiling (lower sec/km).
 */

export function resolveEffectiveThresholdPaceSecPerKm({
  trainingThresholdPaceSecPerKm,
  ceilingThresholdPaceSecPerKm,
} = {}) {
  const candidates = [];
  const training = trainingThresholdPaceSecPerKm;
  const ceiling = ceilingThresholdPaceSecPerKm;
  if (training != null && Number.isFinite(training) && training > 0) candidates.push(training);
  if (ceiling != null && Number.isFinite(ceiling) && ceiling > 0) candidates.push(ceiling);
  if (candidates.length === 0) return null;
  return Math.min(...candidates);
}
